import { create } from 'zustand';
import { getChatbotConfigSection, updateChatbotConfigSection } from '../utils/chatbotConfigAccess';

interface LogosConfig {
  chatbotLogo: string | null;
  botIcon: string | null;
}

interface LogosStore {
  chatbotLogo: string | null;
  botIcon: string | null;
  setLogo: (type: 'chatbot' | 'bot', url: string, chatbotPublicId?: string) => Promise<void>;
  initializeLogos: (logos: { chatbotLogo: string | null; botIcon: string | null }) => void;
}

export const useLogos = create<LogosStore>((set) => ({
  chatbotLogo: null,
  botIcon: null,
  setLogo: async (type, url, chatbotPublicId) => {
    if (!chatbotPublicId) {
      console.error('No chatbotPublicId provided for logo update');
      return;
    }

    try {
      // Get current logos using centralized utility
      const currentLogos = await getChatbotConfigSection<LogosConfig>(
        'logos', 
        chatbotPublicId
      ) || { chatbotLogo: null, botIcon: null };

      const updatedLogos = {
        ...currentLogos,
        [type === 'chatbot' ? 'chatbotLogo' : 'botIcon']: url
      };

      // Update using centralized utility
      const success = await updateChatbotConfigSection(
        'logos',
        updatedLogos,
        chatbotPublicId
      );

      if (!success) {
        throw new Error(`Failed to update ${type} logo`);
      }

      // Update local state only after successful DB update
      set(type === 'chatbot' 
        ? { chatbotLogo: url }
        : { botIcon: url }
      );
    } catch (err) {
      console.error('Error saving logo:', err);
      throw err;
    }
  },
  initializeLogos: (logos) => {
    set({ 
      chatbotLogo: logos.chatbotLogo,
      botIcon: logos.botIcon
    });
  }
}));